import { render, staticRenderFns } from "./ClientAddPage.vue?vue&type=template&id=7051dd1c&scoped=true"
import script from "./ClientAddPage.vue?vue&type=script&lang=ts"
export * from "./ClientAddPage.vue?vue&type=script&lang=ts"
import style0 from "./ClientAddPage.vue?vue&type=style&index=0&id=7051dd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051dd1c",
  null
  
)

export default component.exports